import React from "react";
import { Box, Divider, Typography } from "@mui/material";

import { BASE_CONSTANTS } from "constants/baseConstants";

export const DrawerHeader = ({ children }) => {
  return (
    <Box sx={{ flexShrink: 0 }}>
      <Box
        paddingX={BASE_CONSTANTS.PADDING_MD}
        paddingY={BASE_CONSTANTS.PADDING_SM}
      >
        <Typography variant="h6">{children}</Typography>
      </Box>

      <Divider />
    </Box>
  );
};
